import { createApp } from 'vue'
import App from './App.vue';
import { createStore } from './store'
import { createRouter } from './router'

const router = createRouter()
const store = createStore(router)

const app = createApp(App)
app.use(store)
app.use(router)

app.mount("#app")
